/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from './'
import $const from '../common/constant'

export default {

  //根据parentCode 获取树形部门列表
  getTree: params => {
    return API.GET($const.apiServer.Admin+'/dept/tree', params);
  },
  update: (params,config) => {
    return API.POST($const.apiServer.Admin+'/dept/update',params,config);
  },
  save: (params,config) => {
    return API.POST($const.apiServer.Admin+'/dept/save',params,config);
  },
  remove:params => {
    return API.GET($const.apiServer.Admin+'/dept/remove',params);
  },
  getIdsByUserId:params => {
    return API.GET($const.apiServer.Admin+'/dept/getIdsByUserId',params);
  },
  getStructureUrl:params => {
    return API.GET($const.apiServer.Admin+'/dept/getStructureUrl',params);
  },
  getDeptByUserId:id => {
    return API.GET($const.apiServer.Admin+'/dept/getDeptByUserId?userId='+id);
  },
  getlistAll:params => {
    return API.GET($const.apiServer.Admin+'/dept/listAll',params);
  },
  //根据parentCode 获取树形部门列表
  getTreeByUserId: params => {
    return API.GET($const.apiServer.Admin+'/dept/treeByUserId', params);
  },
  /**
   * 生成企业组织架构图
   * @return
   */
  getOrganizationTree: params => {
    return API.GET($const.apiServer.Admin+'/dept/getOrganizationTree', params);
  },
  getTreeDeptAndUser: params => {
    return API.GET($const.apiServer.Admin+'/dept/getTreeDeptAndUser', params);
  },
  getDeptNodeById: id => {
	return API.GET($const.apiServer.Admin+'/dept/getById?id='+ id);
  },
}



// WEBPACK FOOTER //
// ./src/api/api_dept.js